import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EnrollmentForm from './components/EnrollmentForm';
import './App.css';
import CourseList from './components/Courses/CourseList';
import ReferralRegistration from './components/Referral/ReferralRegistration';
import ReferralDashboard from './components/Referral/ReferralDashboard';
import ScholarshipRegistration from './components/Scholarship/ScholarshipRegistration';
import AmbassadorRegistration from './components/Ambassador/AmbassadorRegistration';
import AdminCredentials from './components/AdminCredentials/AdminCredentials';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CourseList />} />
        <Route path="/enroll" element={<EnrollmentForm />} />
        <Route path="/referral-registration" element={<ReferralRegistration />} />
        <Route path="/ambassador-registration" element={<AmbassadorRegistration />} />
        <Route path='/referral-dashboard' element={<ReferralDashboard />} />
        <Route path="/scholarship-registration" element={<ScholarshipRegistration />} />
        <Route path="/admin" element={<AdminCredentials />} />
      </Routes>
    </Router>
  );
}

export default App;
